import { makeStyles } from "@material-ui/core"

export const BulkEditAssetPopupStyle = makeStyles((theme) => ({
    button: {
        padding: '0.5em 1.5em',
        fontSize: '0.8em'
    },
    icon:{
        color: "#0090fe" 
    }
}));